/**
 * Reduce anything that might name a product — a slug, a full URL, a Tebex
 * package id, a path with a query string — to the bare identifier.
 *
 * This lives on its own rather than in customProducts.js because App.js needs
 * it on every route, and importing it from there dragged the whole custom
 * product catalogue (and the football data it imports) into the chunk every
 * page loads: roughly 49 KB of source for one string function. The catalogue
 * itself is only needed by the custom product page, which is lazy.
 */
export function normalizeProductIdentifier(value) {
  if (value === null || value === undefined) return '';

  let normalized = String(value).trim();
  try {
    normalized = decodeURIComponent(normalized);
  } catch {
    // Keep malformed identifiers untouched so they simply fail resolution.
  }

  normalized = normalized.replace(/^https?:\/\/[^/]+/i, '');
  normalized = normalized.split(/[?#]/, 1)[0];
  normalized = normalized.replace(/^\/+|\/+$/g, '');

  const parts = normalized.split('/').filter(Boolean);
  return (parts[parts.length - 1] || '').toLowerCase();
}
